<template>
    <div class="stale-accounts-wrapper">
        <Row :gutter="32">
            <Form ref="medalForm" :model="medalForm" :rules="medalRules" label-position="top" class="fit-to-content">
                <i-col :xs="12">
                    <FormItem prop="Type" label="Type">
                        <Select v-model="medalForm.Type" placeholder="Select Type" @on-change="typeChange">
                            <Option :value="0">Challenge</Option>
                            <Option :value="1">Planet</Option>
                            <Option :value="2">Block category</Option>
                        </Select>
                    </FormItem>
                    <Table :columns="columns" :loading="dataLoading" :data="typeMedals" style="margin-top: 24px">
                        <div slot-scope="{ row, index }" slot="action">
                            <Button type="error" size="small" @click="deleteMedal(row,index)">Delete</Button>
                        </div>
                    </Table>
                </i-col>
                <i-col :xs="12">
                    <Row :gutter="32" style="width: 800px;">
                        <i-col :xs="8">
                            <FormItem prop="AttachedObject" label="Object Name">
                                <Input type="text" v-model="medalForm.AttachedObject" />
                            </FormItem>
                        </i-col>
                        <i-col :xs="24">
                            <Button type="primary"
                                    :loading="submitLoading"
                                    @click="addNewMedal">
                                <span v-if="!submitLoading">Add Medal</span>
                                <span v-else>Processing...</span>
                            </Button>
                        </i-col>
                    </Row>
                </i-col>
            </Form>
        </Row>
    </div>
</template>

<script>
    import { bus } from "../../main";
    import { getMedals, addMedal, deleteMedal } from "../../_services/medal.service";

    export default {
        data() {
            const validateObjectName = (rule, value, callback) => {
                let duplicateName=this.typeMedals.filter((medal)=>{
                    return medal.AttachedObject===value
                })
                if(duplicateName.length){
                    callback(new Error('Medal already exist.'));
                }else{
                    callback();
                }

            };
            return {
                columns: [
                    {
                        title: "Existing Medals",
                        key: "AttachedObject",
                        className: "capitalize"
                    },
                    {
                        title: " ",
                        slot: "action",
                        width: 150,
                        align: "right"
                    }

                ],
                submitLoading:false,
                medals: [],
                typeMedals:[],
                medalForm:{
                    Type: 0,
                    AttachedObject: "",
                },
                medalRules:{
                    AttachedObject: [
                        {
                            required: true,
                            message: "Please fill up the object name",
                            trigger: "blur"
                        },
                        { validator: validateObjectName, trigger: 'blur' }
                    ],
                },
                dataLoading:true
            };
        },
        methods: {
            getMedalList() {
                this.dataLoading=true
                getMedals().then(res=>{
                    this.medals=res.data.data
                    this.typeMedals=res.data.data.filter(({Type})=>{return Type===this.medalForm.Type})
                    this.dataLoading=false
                }).catch(err=>{
                    bus.$emit('requestError',err)
                    this.dataLoading = false
                })
            },
            typeChange(type){
                this.typeMedals=this.medals.filter(({Type})=>{return Type===type})
            },
            addNewMedal(){
                this.$refs.medalForm.validate(valid => {
                    if (valid) {
                        this.submitLoading=true
                        addMedal(this.medalForm).then(res => {
                            this.getMedalList()
                            this.submitLoading=false
                            this.$Message.success("Successfully added medal.");
                        }).catch(err => {
                            this.$Message.error("Failed to add medal. Please try again later.");
                        })
                    }
                })
            },
            deleteMedal(data,index){
                this.$Modal.confirm({
                    title: 'Remove Language',
                    content: `<p>Are you sure you want to remove <b>${data.AttachedObject}</b>?</p>`,
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteMedal(data._id).then(res=>{
                            this.typeMedals.splice(index,1)
                            this.dataLoading=false
                            this.$Message.success("Successfully deleted medal.");
                        }).catch(err=>{
                            this.dataLoading=false
                            this.$Message.error("Failed to delete medal. Please try again later.");
                        })
                    },
                });
            },
        },
        mounted() {
            // this.languages = languages.map(lang=>{return lang.name})
            this.getMedalList();
        }
    };
</script>
<style scoped>
    .stale-accounts-wrapper{
        width: 800px;
    }
    .remove-all{
        margin-top: 20px;
        float: right;
    }
</style>
